export const theme = {
	light: {
		bg: 'hsl(0, 0%, 100%)',
		bgPattern: 'hsl(225, 100%, 98%)',
		textColor: 'hsl(228, 12%, 44%)',
		darkText: 'hsl(230, 17%, 14%)',
		cardBg: 'hsl(227, 47%, 96%)',
		cardHover: '#E1E4F0',
	},
	dark: {
		bg: 'hsl(230, 17%, 14%)',
		bgPattern: 'hsl(232, 19%, 15%)',
		darkText: 'hsl(0, 0%, 100%)',
		textColor: 'hsl(228, 34%, 66%)',
		cardBg: 'hsl(228, 28%, 20%)',
		cardHover: '#333A55',
	},
};
